<template>
    
    <div class="searchheader-container">
        
        <img :src="images.title" class="searchheader-title" />
    </div>
</template>

<script>

    import ImageTitle from "@/assets/images/search/title.png";

    export default {
        name: "SearchHeader",
        data() {

            return {
                images: {
                    title: ImageTitle
                }
            };
        }
    }
</script>

<style lang="scss" scoped>

    .searchheader-container {

        background-image: url(../assets/images/search/bg-top.png);
        background-position: 50% 50%;
        background-size: cover;
        background-repeat: no-repeat;
        width: 100%;
        height: 7rem;

        .searchheader-title {
            position: relative;
            width: calc(277px / 1.8);
            height: calc(152px / 1.8);
            left: 39%;
            top: 10%;
        }
    }
</style>